var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdenarActivoArriba16X16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99216 1.36993C7.48516 0.676657 8.5147 0.676657 9.00769 1.36993L12.147 5.78453C12.3628 6.08811 12.2917 6.50923 11.9882 6.72511C11.6846 6.94099 11.2635 6.8699 11.0476 6.56631L7.99993 2.28054L4.95227 6.56631C4.73639 6.8699 4.31528 6.94099 4.01169 6.72511C3.70811 6.50923 3.63701 6.08811 3.85289 5.78453L6.99216 1.36993Z",
    fill: "#80CFBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00769 14.63C8.5147 15.3233 7.48516 15.3233 6.99216 14.63L3.85289 10.2154C3.63701 9.91182 3.70811 9.49071 4.01169 9.27483C4.31528 9.05895 4.73639 9.13004 4.95227 9.43363L7.99993 13.7194L11.0476 9.43363C11.2635 9.13004 11.6846 9.05895 11.9882 9.27483C12.2917 9.49071 12.3628 9.91183 12.147 10.2154L9.00769 14.63Z",
    fill: "#E2E5E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdenarActivoArriba16X16);
export default __webpack_public_path__ + "static/media/ORDENAR-ACTIVO-ARRIBA_16X16.3d7d734a9952cc108d4d04d1181b4abe.svg";
export { ForwardRef as ReactComponent };